
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/pay-it-forward",
      function () {
        return require("private-next-pages/[locale]/pay-it-forward/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/pay-it-forward"])
      });
    }
  